import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "../HomePage/HomePage";
import ServicePage from "../ServicePage/ServicePage";
import AboutUsPage from "../AboutUsPage/AboutUsPage";
import PricingPage from "../PricingPage/PricingPage";
import CaseStudyPage from "../CaseStudyPage/CaseStudyPage.jsx";
import CareerPage from "../CareerPage/CareerPage";
import CareerSingle from "../CareerSingle/CareerSingle";
import TeamPage from "../TeamPage/TeamPage";
import TermsPage from "../TermsPage/TermsPage";
import PrivacyPage from "../PrivacyPage/PrivacyPage";
import ContactPage from "../ContactPage/ContactPage";
import CloudServerPage from "../CloudServerPage/CloudServerPage";
import DatacenterVirtualPage from "../DatacenterVirtualPage/DatacenterVirtualPage";
import DisasterRecoveryPage from "../DisasterRecoveryPage/DisasterRecoveryPage";
import CloudVPSPage from "../CloudVPSPage/CloudVPSPage";
import VDIWindows11Page from "../VDIWindows11Page/VDIWindows11Page";
import MicrosoftExchangePage from "../MicrosoftExchangePage/MicrosoftExchangePage";
import FirewallComodatoPage from "../FirewallComodatoPage/FirewallComodatoPage";
import DesenvolvimentoWebPage from "../DesenvolvimentoWebPage/DesenvolvimentoWebPage";
import BackupCloudPage from "../BackupCloudPage/BackupCloudPage";
import CaseStudyMigracaoCloudVPS from "../CaseStudyMigracaoCloudVPS/CaseStudyMigracaoCloudVPS";
import CaseStudyDisasterRecovery from "../CaseStudyDisasterRecovery/CaseStudyDisasterRecovery";
import CaseStudyDatacenterVirtual from "../CaseStudyDatacenterVirtual/CaseStudyDatacenterVirtual";
import CaseStudyVDIWindows11 from "../CaseStudyVDIWindows11/CaseStudyVDIWindows11";

const AllRoute = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="cloud-server" element={<CloudServerPage />} />
          <Route path="data-center-virtual" element={<DatacenterVirtualPage />} />
          <Route path="disaster-recorvery" element={<DisasterRecoveryPage />} />
          <Route path="cloud-vps" element={<CloudVPSPage />} />
          <Route path="vdi-windows11" element={<VDIWindows11Page />} />
          <Route path="microsoft-exchange" element={<MicrosoftExchangePage />} />
          <Route path="firewall-comodato" element={<FirewallComodatoPage />} />
          <Route path="desenvolvimento-web" element={<DesenvolvimentoWebPage />} />
          <Route path="backup-cloud" element={<BackupCloudPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="projects" element={<CaseStudyPage />} />
          <Route path="project-details/migracao-cloud-vps-industria-alimenticia" element={<CaseStudyMigracaoCloudVPS />} />
          <Route path="project-details/disaster-recovery-grupo-hospitalar" element={<CaseStudyDisasterRecovery />} />
          <Route path="project-details/datacenter-virtual-empresa-logistica" element={<CaseStudyDatacenterVirtual />} />
          <Route path="project-details/vdi-windows-11-escritorio-advocacia" element={<CaseStudyVDIWindows11 />} />
          <Route path="casestudy-details/migracao-cloud-vps-industria-alimenticia" element={<CaseStudyMigracaoCloudVPS />} />
          <Route path="casestudy-details/disaster-recovery-grupo-hospitalar" element={<CaseStudyDisasterRecovery />} />
          <Route path="casestudy-details/datacenter-virtual-empresa-logistica" element={<CaseStudyDatacenterVirtual />} />
          <Route path="casestudy-details/vdi-windows-11-escritorio-advocacia" element={<CaseStudyVDIWindows11 />} />
          <Route path="career" element={<CareerPage />} />
          <Route path="career-details" element={<CareerSingle />} />
          <Route path="terms-conditions" element={<TermsPage />} />
          <Route path="privacy-policy" element={<PrivacyPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
